var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my_order"},[_c('div',{staticClass:"order_main"},[_c('div',{staticClass:"order_left"},[_c('user-tab')],1),_c('div',{staticClass:"order_right"},[_c('router-view')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }